export default class StringUtils {

    static deleteWhitespace( str: string ): string {
        return str ? str.replace( /\s/g, "" ) : str;
    }
}